module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticStyle: {
      "text-align": "center",
      "font-size": "25px",
      "color": "orange",
      "margin-top": "100px"
    }
  }, [_vm._v("This is broadcast page!")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65e49066!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/broadcast/broadcast.vue
// module id = 59
// module chunks = 1